/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/*
 * Author M. Atoar Rahman
 * Title: Current Stock
 * Description: CurrentData for Current Stock
 * Date: 13/07/2022
 */

import { useCallback, useEffect, useState } from 'react';
import { Button, Card, Col, Row, Tab, Tabs } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import CommonApiService from '../../../services/CommonApiService';
import { makeGroupBy, sumOfTotal } from '../../../Utils';
import { useCurrentStock } from './ContextAPI';
import DataTable from './DataTable';

export default function CurrentData() {
    const { drugCategory, getDrugCategory } = CommonApiService();
    const { data, setShowPdf, setShowForm } = useCurrentStock();
    const [page, setPage] = useState(0);
    const [pageLength, setPageLength] = useState(0);

    // console.log({ rowData });

    const dataList = useCallback(() => {
        getDrugCategory(); //  Drug Category
    }, []);

    useEffect(() => {
        dataList();
    }, [dataList]);

    useEffect(() => {
        setPageLength(drugCategory?.length);
    }, [drugCategory]);

    const handlePrintPreview = () => {
        setShowPdf(true);
        setShowForm(false);
    };

    const handleClose = () => {
        setShowPdf(false);
        setShowForm(true);
    };
    const tableDataDisplay = () =>
        drugCategory?.map((item, index) => (
            <Tab key={item.id} eventKey={index} title={item.name}>
                <div className="dataTableHeaderNone padding-0">
                    <DataTable data={data?.filter((el) => el.category_id == item.id)} />
                </div>
            </Tab>
        ));

    const exportAllTabsToMultiSheet = () => {
        const wb = XLSX.utils.book_new();
        drugCategory?.forEach((cat) => {
            const filtered =
                data?.filter((item) => parseFloat(item.category_id) === parseFloat(cat.id)) || [];
            const formatted = filtered.flatMap((item) => {
                // Same logic as DataTable.jsx: makeGroupBy by batch_no + sumOfTotal
                const groupData = makeGroupBy(item.batch_info, 'batch_no');
                return Object.entries(groupData).map(([, rows]) => ({
                    // Category: cat.name,
                    'Code No': item.code_no,
                    Item: item.drug_name.replace(/^\S+\s*/, ''),
                    'Batch No': rows[0].batch_no,
                    'Expired Date': rows[0].expire_date,
                    'Current Date': new Date().toISOString().split('T')[0],
                    'Available Qty': sumOfTotal(rows),
                    'Unit Price': rows[0].unit_price,
                    'Total Value': sumOfTotal(rows) * rows[0].unit_price,
                    'Location From': item.warehouse_name
                        ? item.warehouse_name
                        : item.facility_name
                        ? item.facility_name
                        : item?.partner_name
                        ? item.partner_name
                        : item?.dispensary_name,
                }));
            });
            const ws = XLSX.utils.json_to_sheet(formatted);
            XLSX.utils.book_append_sheet(wb, ws, cat.name?.slice(0, 31)); // Excel sheet name limit
        });

        XLSX.writeFile(wb, 'CurrentStock_MultiSheet.xlsx');
    };

    return (
        <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
                <h6>Central Current Stock</h6>
                <div>
                    <Button
                        onClick={() => handleClose()}
                        className="btnCancel me-2"
                        variant="primary"
                    >
                        <i className="fa-solid fa-arrow-left" /> Back
                    </Button>
                    <Button className="btn btn-dark me-2" onClick={handlePrintPreview}>
                        Print Preview
                    </Button>
                    <Button className="btn btn-success" onClick={exportAllTabsToMultiSheet}>
                        Export Excel
                    </Button>
                </div>
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col>
                        <Tabs
                            activeKey={page}
                            transition={false}
                            id="noanim-tab-example"
                            className="mb-3"
                            // eslint-disable-next-line radix
                            onSelect={(k) => setPage(parseInt(k))}
                        >
                            {tableDataDisplay()}
                        </Tabs>
                    </Col>
                </Row>

                <div className="formFooter">
                    <Button onClick={() => handleClose()} className="btnCancel" variant="primary">
                        Close
                    </Button>
                    <Button
                        className={`btnInfo me-2 ms-2 ${page === 0 && 'd-none'}`}
                        variant="secondary"
                        onClick={() => {
                            setPage((currPage) => currPage - 1);
                        }}
                    >
                        Prev
                    </Button>
                    <Button
                        type="button"
                        className="btnSuccess"
                        disabled={page == pageLength - 1}
                        variant="success"
                        style={{ minWidth: '6rem' }}
                        onClick={() => setPage((currPage) => currPage + 1)}
                    >
                        Next
                    </Button>
                </div>
            </Card.Body>
        </Card>
    );
}
